module.exports = __webpack_public_path__ + "img/heroLines.9136409e.svg";